import React, { ReactNode } from "react";
import { LoadingContainer } from "./style";
import { SpinnerLoading } from "../../spinner-loading";

interface IContainerLoadingProps {
  children: ReactNode;
  loading: boolean;
  width?: string;
  size?: number;
}

export const ContainerLoading: React.FC<IContainerLoadingProps> = ({
  children,
  loading,
  width = "100%",
  size = 80,
}) =>
  loading ? (
    <LoadingContainer width={width}>
      <SpinnerLoading size={size} />
    </LoadingContainer>
  ) : (
    <>{children}</>
  );
